import { useState, useEffect } from "react";
import { VALIDATION_ERROR } from "../app/errors";
import { ErrorWithString } from "./RegularComponents";

const DateSelectionForm = (props) => {
  const { id, date, hideYear = false } = props;
  let dateObj;
  if (parseInt(date) > 0) {
    dateObj = new Date(parseInt(date));
  }

  const [day, setDay] = useState(dateObj ? dateObj.getDate() : "");
  const [month, setMonth] = useState(dateObj ? dateObj.getMonth() + 1 : "");
  const [year, setYear] = useState(dateObj ? dateObj.getFullYear() : "");

  const [showValidationError, setShowValidationError] = useState(
    props.showValidationError
  );

  const [dateError, setDateError] = useState(VALIDATION_ERROR.NO_ERROR);

  useEffect(() => {
    if (hideYear) {
      const currentTime = new Date();
      setYear(currentTime.getFullYear());
    }
  }, [hideYear]);

  useEffect(() => {
    const validateDate = () => {
      if (!day && !month && !year) {
        setDateError(VALIDATION_ERROR.EMPTY);
        return false;
      }

      let d = parseInt(day);
      let m = parseInt(month);
      let y = parseInt(year);

      if (!d || d < 1 || d > 31) {
        setDateError(VALIDATION_ERROR.DATE_DAY_INVALID);
        return false;
      }

      if (!m || m < 1 || m > 12) {
        setDateError(VALIDATION_ERROR.DATE_MONTH_INVALID);
        return false;
      }

      if (!y || y < 1980) {
        setDateError(VALIDATION_ERROR.DATE_YEAR_INVALID);
        return false;
      }

      if (props.disableFutureDate) {
        const dateObj = new Date(y, m - 1, d);
        if (dateObj.getTime() > Date.now()) {
          setDateError(VALIDATION_ERROR.DATE_IN_FUTURE);
          return false;
        }
      }

      setDateError(VALIDATION_ERROR.NO_ERROR);
      return true;
    };

    if (parseInt(date) > 0) {
      const dateObj = new Date(parseInt(date));
      setDay(dateObj.getDate());
      setMonth(dateObj.getMonth() + 1);
      setYear(dateObj.getFullYear());
    } else {
      setDay(day);
      setMonth(month);
      setYear(year);
    }

    setShowValidationError(props.showValidationError);
    validateDate();
  }, [
    date,
    day,
    month,
    year,
    props.showValidationError,
    props.disableFutureDate,
    setShowValidationError,
  ]);

  const isDateValid = () => {
    if (showValidationError) {
      return dateError === VALIDATION_ERROR.NO_ERROR;
    }

    return true;
  };

  const dateErrorString = () => {
    switch (dateError) {
      case VALIDATION_ERROR.EMPTY:
        return "Enter a date";
      case VALIDATION_ERROR.DATE_INVALID:
      case VALIDATION_ERROR.DATE_DAY_INVALID:
      case VALIDATION_ERROR.DATE_MONTH_INVALID:
      case VALIDATION_ERROR.DATE_YEAR_INVALID:
        return "Enter a valid date";
      case VALIDATION_ERROR.DATE_IN_FUTURE:
        return "Date can't be in future";
      default:
        return "";
    }
  };

  const onInputChange = (e) => {
    let updateDay = day;
    let updateMonth = month;
    let updateYear = year;
    let properDate = false;

    if (e.target.id.indexOf("day") !== -1) {
      updateDay = e.target.value;
      setDay(updateDay);
    } else if (e.target.id.indexOf("month") !== -1) {
      updateMonth = e.target.value;
      setMonth(updateMonth);
    } else if (e.target.id.indexOf("year") !== -1) {
      updateYear = e.target.value;
      setYear(updateYear);
    }

    if (hideYear) {
      const currentTime = new Date();
      setYear(currentTime.getFullYear());
    }

    if (
      updateDay >= 1 &&
      updateDay <= 31 &&
      updateMonth >= 1 &&
      updateMonth <= 12 &&
      updateYear >= 1900
    ) {
      properDate = true;
    }

    if (props.onDateChange) {
      if (properDate) {
        const dateObj = new Date(updateYear, updateMonth - 1, updateDay);

        if (!isNaN(dateObj.getTime())) {
          props.onDateChange(dateObj.getTime());
        } else {
          props.onDateChange(0);
        }
      } else {
        props.onDateChange(0);
      }
    }
  };

  return (
    <>
      {!isDateValid() && (
        <span
          id={id + "-date-error"}
          className="ns-error-message field-validation-error"
        >
          {ErrorWithString(dateErrorString())}
        </span>
      )}
      <div className="ns-fieldset">
        <fieldset aria-describedby="date-entry">
          {/* <legend className="ns-fieldset__legend noBorder label">
                    Date
                </legend> */}
          <div className="row">
            <div className="col-auto">
              <label htmlFor={id + "-day-input"}>DD</label>
              <input
                disabled={props.readOnly}
                className={
                  "fw-2" + (!isDateValid() ? " ns-input--error" : " ns-input")
                }
                id={id + "-day-input"}
                pattern={"[0-9]*"}
                inputMode="numeric"
                name={id + "-day-input"}
                value={day}
                onInput={onInputChange}
                type={"text"}
              />
            </div>
            <div className="col-auto">
              <label htmlFor={id + "-month-input"}>MM</label>
              <input
                disabled={props.readOnly}
                className={
                  "fw-2" + (!isDateValid() ? " ns-input--error" : " ns-input")
                }
                name={id + "-month-input"}
                id={id + "-month-input"}
                pattern={"[0-9]*"}
                inputMode="numeric"
                value={month}
                onInput={onInputChange}
                type={"text"}
              />
            </div>
            {!hideYear && (
              <div className="col-auto">
                <label htmlFor={id + "-year-input"}>YYYY</label>
                <input
                  disabled={props.readOnly}
                  className={
                    "fw-4" + (!isDateValid() ? " ns-input--error" : " ns-input")
                  }
                  name={id + "-year-input"}
                  id={id + "-year-input"}
                  pattern={"[0-9]*"}
                  inputMode="numeric"
                  value={year}
                  onInput={onInputChange}
                  type={"text"}
                />
              </div>
            )}
          </div>
        </fieldset>
      </div>
    </>
  );
};

export default DateSelectionForm;
